import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class NorthwesternMutualIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.NORTHWESTERN_MUTUAL_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    getNorthwesternMutualClientSearchResults(searchTerms, page) {
        const baseUrl = this.urlsService.INTEGRATIONS.NORTHWESTERN_MUTUAL_CLIENT_SEARCH;
        const url = `${baseUrl}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getNorthwesternMutualClientAccountSearchResults(clientId, page) {
        const baseUrl = this.urlsService.INTEGRATIONS.NORTHWESTERN_MUTUAL_CLIENT_ACCOUNT_SEARCH;
        const url = `${baseUrl}?clientId=${clientId}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    importNorthwesternMutualAccountHoldings(importType, postParams) {
        const urlParams = { importType };
        const url = this.urlsService.getUrl(this.urlsService.INTEGRATIONS.NORTHWESTERN_MUTUAL_IMPORT_ACCOUNT_HOLDINGS, urlParams);
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
}
NorthwesternMutualIntegrationService.ɵfac = function NorthwesternMutualIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NorthwesternMutualIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
NorthwesternMutualIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NorthwesternMutualIntegrationService, factory: NorthwesternMutualIntegrationService.ɵfac, providedIn: 'root' });
